var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCctv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#8C62FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1828 21.4832C13.9953 21.7498 14.0613 22.1168 14.3277 22.302L14.7304 22.5816C14.0732 23.2158 13.1917 23.5746 12.2711 23.5746H11.1719V22.3051C11.1719 21.9815 10.9095 21.7191 10.5859 21.7191C10.2623 21.7191 10 21.9815 10 22.3051V28.2816C10 28.6052 10.2623 28.8676 10.5859 28.8676C10.9095 28.8676 11.1719 28.6052 11.1719 28.2816V27.0902H11.9661C14.0689 27.0902 16.1253 26.206 17.5861 24.5648L18.1723 24.9719C18.4384 25.1577 18.8076 25.0895 18.9906 24.8203L19.3922 24.2309L14.6387 20.8359L14.1828 21.4832Z",
    fill: "#8C62FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7443 21.5344L29.5283 21.3867L25.0342 24.9777L26.3201 25.9035C26.5712 26.0843 26.9224 26.0386 27.1182 25.7957L29.8697 22.3863C30.0854 22.1189 30.0254 21.7261 29.7443 21.5344Z",
    fill: "#8C62FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8349 19.4914L17.5682 11.3549C17.0621 10.9894 16.3595 11.0844 15.9685 11.571L12.2658 16.1798C11.8447 16.7041 11.951 17.4765 12.4983 17.8674L22.4659 24.9856C22.6789 25.1377 22.9674 25.1302 23.1722 24.9665L28.8576 20.4242C29.1597 20.1829 29.1493 19.7184 28.8349 19.4914ZM24.6878 20.5276C24.3642 20.5276 24.1018 20.2652 24.1018 19.9417C24.1018 19.6181 24.3642 19.3557 24.6878 19.3557C25.0113 19.3557 25.2737 19.6181 25.2737 19.9417C25.2737 20.2652 25.0113 20.5276 24.6878 20.5276Z",
    fill: "#8C62FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCctv);
export default __webpack_public_path__ + "static/media/cctv.dc1528e886311533e8a878a4b530df73.svg";
export { ForwardRef as ReactComponent };